import BroadcastListService from '../../../views/ChatBroadcastList/service';
import FlexChatIntegration from 'views/ServicePanel/components/QueueContent/components/Contact/service/FlexChatIntegration';

/**
 * Hook personalizado para lidar com a importação e validação de dados de lista de transmissão.
 *
 * @param {string|number} broadcastListId - O ID da lista de transmissão para importar dados.
 * @returns {Object} Um objeto contendo o seguinte:
 *   @returns {Function} loadBroadcastListFields - Função assíncrona para buscar e configurar o mapeamento de campos da lista de transmissão.
 *   @returns {Function} validateBroadcastListData - Função para validar dados importados de acordo com os mapeamentos de campos.
 *   @returns {Object} mapHeadersProtocol - Objeto mapeando cabeçalhos de protocolo para valores booleanos.
 *   @returns {Object} mapHeadersImportField - Objeto mapeando cabeçalhos de campos de importação para valores booleanos.
 */

export const useImportBroadcastList = (broadcastListId) => {
  const loadBroadcastListFields = async () => {
    try {
      let fieldsProtocolLabelMap = {};
      let fieldsImportLabelMap = {};

      const broadcastList = await FlexChatIntegration.getBroadcastListById(
        broadcastListId
      );

      let dataBroadcastList = broadcastList.data?.data ?? {};
      let customFields = [];
      let defaultFields = [];
      if (dataBroadcastList?.recordTypeId) {
        [customFields, defaultFields] = await Promise.all([
          BroadcastListService.getProtocoloCustomFieldsByRecordType(
            dataBroadcastList?.recordTypeId
          ),
          BroadcastListService.getProtocolFieldsDefaultByRecordType(
            dataBroadcastList?.recordTypeId
          )
        ]);
      }

      const configFieldsProtocol = new Map(
        customFields?.map((field) => [
          field.name,
          {
            isRequired: field.recordTypesConfig[0]?.isRequired,
            label: field.label,
            type: field.type
          }
        ])
      );

      Object.keys(defaultFields).forEach((key) => {
        const currentConfig = defaultFields[key];
        configFieldsProtocol.set(key, {
          isRequired: currentConfig.isRequired,
          label: key,
          type: 'TEXT'
        });
      });

      const inputsToMap = [
        ...(dataBroadcastList?.params
          ?.filter((param) => param.type === 'import_field')
          ?.map((field) => {
            return {
              isRequired: true,
              label: field?.value,
              type: 'TEXT',
              name: field?.value,
              isTemplateParams: true,
              id: field.value
            };
          }) ?? []),
        ...(dataBroadcastList?.protocolParams
          ?.filter((param) => param.type === 'import_field')
          ?.map((field) => {
            const config = configFieldsProtocol.get(field?.protocol_column);
            return {
              ...field,
              id: field?.value,
              isRequired: config?.isRequired ?? false,
              label: config?.label,
              type: config?.type ?? 'TEXT',
              name: field?.value,
              isProtocolParams: true
            };
          }) ?? [])
      ];
      return {
        fieldsProtocolLabelMap,
        fieldsImportLabelMap,
        inputsToMap: inputsToMap ?? []
      };
    } catch (error) {
      console.error('Error loading broadcast list fields:', error);
    }
  };

  return {
    loadBroadcastListFields
  };
};
